<template>
    <div>
        <h1>{{ $t("product.create") }}</h1>
        <div class="row">
            <div class="col-12">
                <p>{{ $t("product.name") }}</p>
                <input class="form-control" v-model="product.name">
            </div>
            <div class="col-12">
                <p>{{ $t("product.purchasePrice") }}</p>
                <input class="form-control" v-model="product.purchase_price">
            </div>
            <div class="col-12">
                <p>{{ $t("product.defaultPriceIncreaseBy") }}</p>
                <input class="form-control" v-model="product.default_price_increase_by">
            </div>
            <div class="col-12">
                <p>{{ $t("product.informations") }}</p>
                <textarea class="form-control" v-model="product.informations"/>
            </div>
            <div class="col-12">
                <p>{{ $t("product.category") }}</p>
                <VueMultiselect
                    :options="categories"
                    v-model="product.category"
                    label="name"
                    track-by="id"
                    class="w-100"
                    :select-label="$t('multiselect.pressToSelect')"
                    :selected-label="$t('multiselect.selected')"
                    :multiple="false"
                    :deselect-label="$t('multiselect.pressToDeselect')"
                    :showNoResults="false">
                </VueMultiselect>
            </div>
            <div class="col-12">
                <button class="btn btn-primary" @click="save">{{ $t("product.save") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';
export default {
    components: {
        VueMultiselect
    },
    data() {
        return {
            product: {
                product_id: null,
                category: null,
                name: null,
                purchase_price: null,
                default_price_increase_by: null,
                informations: null,
                hidden: null
            },
            categories: [],
            loading: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/product_categories").then(function (response) {
                this.categories = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        save: function () {
            this.$store.getters.api.post("/product/create", this.product).then(function (response) {
                this.$router.push({"name": "product", "params": {"id": response.data.id}})
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>